// Chakra imports
import { Box, Grid, useColorModeValue } from "@chakra-ui/react";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";

// Custom components
import Banner from "views/admin/profile/components/Banner";
import General from "views/admin/profile/components/General";
import Notifications from "views/admin/profile/components/Notifications";
import Projects from "views/admin/profile/components/Projects";
import Storage from "views/admin/profile/components/Storage";
import Information from "views/admin/profile/components/Information";

// Assets
import banner from "assets/img/dailyvibe.png";
import logo from "assets/img/logo.png";
// import avatar from "assets/img/avatars/avatar4.png";
import React, { useEffect, useState } from "react";
import Upload from "./components/Upload";
import ServiceTable from "./components/ServiceTable";
import { columnsDataService } from "./variables/columnsData";
import { CircularProgress, SnackbarContent } from "@mui/material";
import axios from "axios";
import PurchaseHistory from "../purchaseHistory";
import FriendList from "../friendList";
import { useLocation } from "react-router-dom";

export default function Overview() {
  const [user, setUser] = useState();
  const [service, setService] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [loadingItems, setLoadingItems] = useState({});
  const [justPurchasedId, setJustPurchasedId] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // set user dari localStorage saat mount (sudah ada di kodemu)
    let localUser = localStorage.getItem("user");
    if (localUser) {
      setUser(JSON.parse(localUser));
    } else {
      window.location.assign("/home");
    }

    // handler untuk event userUpdated
    const onUserUpdated = (e) => {
      const freshUser = e?.detail?.user;
      if (freshUser) {
        setUser(freshUser);
      } else {
        // fallback baca localStorage
        const stored = localStorage.getItem("user");
        if (stored) setUser(JSON.parse(stored));
      }
    };

    window.addEventListener("userUpdated", onUserUpdated);

    return () => {
      window.removeEventListener("userUpdated", onUserUpdated);
    };
  }, []);

  useEffect(() => {
    let ignore = false;

    const openElement = () => {
      if (location.search && !ignore) {
        const item = location.search?.slice(1)?.split("?");
        const pairs = item[0]?.split("=");
      } else if (location.hash && !ignore) {
        const item = location.hash.slice(1)?.split("#");
        const ele = document.getElementById(item[0]);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
        // setActiveType(item[0])
      } else if (!ignore) {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }
    };

    // Delay the open action to give time for rendering the target element
    const timeoutId = setTimeout(openElement, 500); // 500ms delay

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);
      ignore = true;
    };
  }, [location.hash]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`https://api.personatalenta.id/user/service/table-list`, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
      })
      .then((res) => {
        if (res?.data?.products) {
          setService(res.data.products);
          const lastPurchasedId = sessionStorage.getItem("last_purchased_id");
          if (lastPurchasedId) {
            setJustPurchasedId(parseInt(lastPurchasedId));
            sessionStorage.removeItem("last_purchased_id");
          }
        }
      })
      .catch((err) => {
        if (
          err.response?.data?.message === "Unauthorized" ||
          err?.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, []);

  const onClickCategory = (props) => {
    if (props.category === "Web View" && props.service === "webview") {
      window.location.assign(
        `/dashboard/profile/${
          user?.username !== "" &&
          user?.username !== undefined &&
          user?.username !== null
            ? user.username
            : user?.id
        }/profiling-web`
      );
    } else if (props.category === "Web View" && props.service === "persona") {
      window.location.assign(
        `/dashboard/profile/${
          user?.username !== "" &&
          user?.username !== undefined &&
          user?.username !== null
            ? user.username
            : user?.id
        }/persona-web`
      );
    } else if (props.category === "Web View" && props.service === "matching") {
      window.location.assign(`/matching`);
    }
  };

  const onClickDetail = (props) => {
    if (
      props.category === "File PDF" &&
      props.name === "Standard Profiling Book"
    ) {
      window.location.assign(
        `/dashboard/profile/${
          user?.username !== "" &&
          user?.username !== undefined &&
          user?.username !== null
            ? user.username
            : user?.id
        }/profiling-standard-web`
      );
    } else if (
      props.category === "File PDF" &&
      props.name === "Complete Profiling Book"
    ) {
      window.location.assign(
        `/dashboard/profile/${
          user?.username !== "" &&
          user?.username !== undefined &&
          user?.username !== null
            ? user.username
            : user?.id
        }/profiling-complete-web`
      );
    }
  };

  const onClickDownload = (props) => {
    setLoadingDownload(true);
    setErrorMessage("");
    setLoadingItems((prev) => ({ ...prev, [props.index]: true })); // Set individual item loading
    const token = localStorage.getItem("token");
    setLoading(true);
    console.log(props);
    let baseUrl;
    if (
      props.category === "File PDF" &&
      props.name === "Potential Talent Profiling Book"
    ) {
      baseUrl = `https://api.personatalenta.id/profiling/pdf/talent`;
    } else if (
      props.category === "File PDF" &&
      props.name === "Complete Profiling Book"
    ) {
      baseUrl = `https://api.personatalenta.id/profiling/pdf/complete`;
    } else if (
      props.category === "File PDF" &&
      props.name === "Career Profiling Book"
    ) {
      baseUrl = `https://api.personatalenta.id/profiling/pdf/career`;
    } else if (
      props.category === "File PDF" &&
      props.name === "Relationship Profiling Book"
    ) {
      baseUrl = `https://api.personatalenta.id/profiling/pdf/relation`;
    } else if (
      props.category === "File PDF" &&
      props.name === "Workstyle Profiling Book"
    ) {
      baseUrl = `https://api.personatalenta.id/profiling/pdf/workstyle`;
    }
    axios
      .get(baseUrl, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
        },
        responseType: "blob",
      })
      .then((res) => {
        setLoading(false);
        setLoadingDownload(false);
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(res.data);
        a.download = `${
          props.name === "Career Profiling Book"
            ? "Karir Terbaik Untuk"
            : props.name
        } ${user.name}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => {
        setLoading(false);
        if (
          err.response?.data?.message === "Unauthorized" ||
          err.response?.data === "Unauthorized"
        ) {
          // navigate('/');
        }
        setLoadingDownload(false);
        setErrorMessage(err.message);
      })
      .finally(() => {
        setLoadingItems((prev) => ({ ...prev, [props.index]: false })); // Reset loading after completion
      });
  };

  const onClickBuy = (props) => {
    sessionStorage.setItem("last_purchased_id", props.id);
    window.location.assign(
      `/dashboard/profile/${user?.username}/checkout/${props.id}`
    );
    // if (props.service === "profiling") {
    //   window.location.assign(`/dashboard/profile/${user?.username}/product/profiling-book`)
    // } else if (props.service === "webview") {
    //   window.location.assign(`/dashboard/profile/${user?.username}/product/profiling-web`)
    // } else if (props.service === "Persona" && props.name === "General Persona") {
    //   window.location.assign(`/dashboard/profile/${user?.username}/product/persona`)
    // } else if (props.service === "Persona" && props.name === "Daily Vibe Persona") {
    //   window.location.assign(`/dashboard/profile/${user?.username}/product/daily-vibe`)
    // } else if (props.service === "matching") {
    //   window.location.assign(`/dashboard/profile/${user?.username}/product/matching`)
    // }
  };
  const onClickPrice = (props) => {
    if (props.service === "profiling" || props.service === "webview") {
      window.location.assign(`/pricing#profiling`);
    } else if (
      props.service === "Persona" ||
      props.name === "General Persona" ||
      props.name === "Daily Vibe"
    ) {
      window.location.assign(`/pricing#persona`);
      //   window.location.assign(`/dashboard/profile/${user?.username}/product/persona`)
    } else if (props.service === "matching") {
      window.location.assign(`/pricing#matching`);
      //   window.location.assign(`/dashboard/profile/${user?.username}/product/matching`)
    }
  };

  const onClickEdit = () => {
    window.location.assign(
      `/dashboard/profile/${
        user?.username !== "" &&
        user?.username !== undefined &&
        user?.username !== null
          ? user.username
          : user?.id
      }/edit`
    );
  };

  const handleClose = () => {
    setLoadingDownload(false);
  };

  const handleCloseError = () => {
    setErrorMessage("");
  };

  const action = (
    <div>
      <CircularProgress size={25} />
    </div>
  );

  return (
    <Box pt={{ sm: 0, base: "130px", md: "20px", xl: "20px" }}>
      <Grid gap={{ base: "20px", xl: "20px" }} mt={{ sm: 0, md: 0 }}>
        <Banner
          avatar={user?.photo}
          name={user?.name}
          job={user?.occupation}
          dob={user?.birth_date}
          onClickEdit={onClickEdit}
        />
        <ServiceTable
          columnsData={columnsDataService}
          tableData={service}
          onClickCategory={onClickCategory}
          onClickBuy={onClickBuy}
          onClickPrice={onClickPrice}
          onClickDetail={onClickDetail}
          onClickDownload={onClickDownload}
          loading={loadingItems}
          user={user}
          justPurchasedId={justPurchasedId}
        />
        <PurchaseHistory />
        <FriendList />
      </Grid>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={loadingDownload}
        onClose={handleClose}
        style={{ top: 50 }}
      >
        <SnackbarContent
          style={{ height: 70, backgroundColor: "#CADFB8", color: "#000" }}
          action={action}
          message={
            <div>
              <span id="client-snackbar">
                Saat ini dokumen sedang proses download, kecepatan bergantung pada jaringan anda
              </span>
            </div>
          }
        />
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={errorMessage !== ""}
        onClose={handleCloseError}
        style={{ top: 50 }}
      >
        <SnackbarContent
          style={{ height: 60, backgroundColor: "#FCEF91", color: "#000" }}
          message={
            <div>
              <span id="client-snackbar">{errorMessage}</span>
            </div>
          }
        />
      </Snackbar>
    </Box>
  );
}
